import React from 'react';

import { connectSearchBox } from 'react-instantsearch-dom';

import { Search } from '../Search';

const SearchBox = ({
  refine,
  currentRefinement,
  wrapperClass = '',
  withClear = false,
  handleClear,
}) => {
  return (
    <Search
      refine={refine}
      currentRefinement={currentRefinement}
      wrapperClass={wrapperClass}
      withClear={withClear}
      handleClear={handleClear}
    />
  );
};

export default connectSearchBox(SearchBox);
